import { SWToolTip } from 'components/SWToolTip';
import { MutedTypography, StyledTypography } from './AssetCard.styles';
import { ThemePalette } from 'mui.theme';
import { CallMade, CallReceived } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useAppTheme from 'hooks/useAppTheme';
import { useCallback } from 'react';
import { truncateTo2dp } from 'utils/helpers/general';
import { useAppSelector } from 'store/hook';
import LoadingDots from '../LoadingDots';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _dark = clientThemePalette[CLIENT_THEME].dark;

interface KPICardProps {
  title: string;
  value?: string | number;
  unit?: string;
  diffValue?: number;
  trendDirection?: 'up' | 'down';
  toolTipTitle?: string;
  navigateTo?: string;
  navigateState?: Record<string, any>;
  valueColor?: string;
}
export function AssetItemKPICard({
  title,
  value,
  unit,
  diffValue,
  trendDirection,
  toolTipTitle,
  navigateTo,
  navigateState,
  valueColor,
}: KPICardProps) {
  const isLoadingAllAssets = useAppSelector(
    (state) => state.assetReducer.isLoadingAllAssets
  );
  const navigate = useNavigate();
  const { enableDarkTheme } = useAppTheme();
  const handleNavigate = useCallback(() => {
    if (isLoadingAllAssets) return;
    if (!navigateTo) return;
    navigate(navigateTo, {
      state: navigateState,
    });
  }, [isLoadingAllAssets, navigate, navigateState, navigateTo]);
  return (
    <SWToolTip title={toolTipTitle ?? (value ? `${value} ${unit}` : 'N/A')}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          // flexWrap: 'wrap',
          justifyContent: 'start',
          alignItems: 'start',
          border: '1px solid #66666666',
          borderRadius: '5px',
          padding: '4px',
          cursor: navigateTo ? 'pointer' : 'default',
          transition: 'all 0.2s ease-in-out',
          backgroundColor: enableDarkTheme ? _dark.boxBackground : '#F0F3F6',
        }}
        onClick={handleNavigate}
      >
        <MutedTypography
          enabledarktheme={enableDarkTheme}
          sx={{ fontWeight: '900' }}
        >
          {title}
        </MutedTypography>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            gap: '4px',
          }}
        >
          <StyledTypography
            enabledarktheme={enableDarkTheme}
            fontWeight="900"
            sx={{
              fontSize: '10px',
              color: valueColor && `${valueColor} !important`,
            }}
          >
            {isLoadingAllAssets ? (
              <LoadingDots enableDarkTheme={enableDarkTheme} />
            ) : value ? (
              `${value} ${unit}`
            ) : (
              'N/A'
            )}
          </StyledTypography>
          {diffValue ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                color:
                  trendDirection === 'up'
                    ? ThemePalette.typography.lightSuccess
                    : ThemePalette.typography.lightDanger,
              }}
            >
              {trendDirection === 'up' ? (
                <CallMade
                  sx={{
                    paddingTop: '3px',
                    paddingRight: '5px',
                    fontSize: '10px',
                    color: ThemePalette.typography.lightSuccess,
                  }}
                />
              ) : (
                <CallReceived
                  sx={{
                    paddingTop: '3px',
                    paddingRight: '5px',
                    fontSize: '10px',
                    color: ThemePalette.typography.lightDanger,
                  }}
                />
              )}
              <StyledTypography
                enabledarktheme={enableDarkTheme}
                fontWeight="900"
                sx={{
                  fontSize: '11px',
                  color: 'inherit !important',
                }}
              >
                {diffValue ? `${truncateTo2dp(Math.abs(diffValue))}%` : 'N/A'}
              </StyledTypography>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </SWToolTip>
  );
}

export default AssetItemKPICard;
